import { BenefitsEntity } from "./benefits.model";
import { EnhancementsEntity } from "./enhancements.model";

export interface JobOffer {
  optimize_location?: boolean;
  JobTargets: Array<object>;
  Location: object;
  Sector: object;
  Type: object;
  id: number;
  cities_id: number;
  countries_id: number;
  // course_tag: string,
  courses_id: number;
  description: string;
  expiration_date: Date;
  external_url: string;
  faculties_id: number;
  faculty_tag: string;
  from_date: Date;
  has_story: Boolean;
  img: string;
  is_paid: Boolean;
  locations_id: number;
  position: string;
  removed: Boolean;
  requirements: string;
  sectors_id: number;
  sort_date: Date;
  state: string;
  story_directions: string;
  to_date: Date;
  types_id: number;
  universities_id: number;
  users_id: number;
  view: Boolean;
  job_detail_img;
  job_video;
  job_video_thumbnail;
  slug: string;
  JobRequireSkills?: any[];
  Content: Content;
  enhancements?: EnhancementsEntity[] | null;
  benefits?: BenefitsEntity[] | null;
  salary: string;
  geolocations: JobGeolocationModel[];
  optimize_proximity: boolean;
}

export class JobGeolocationModel {
  geolocations_id: number | string;
  input_value: string;
}

export class JobPostGeolocationModel {
  addresses_id: string | number;
  input_value: string;
}

export class Content {
  id: number;
  title: string;
  text: string;
  abstract?: null;
  type: string;
  tags: string;
  slug: string;
  media_sets_id: number;
  filter_definitions_id: number;
  view: boolean;
  sort_date: string;
  created_at: string;
  updated_at: string;
  FilterDefinition: ContentFilterDefinition;
}
export class ContentFilterDefinition {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  Filters?: FiltersEntity[] | null;
}
export class FiltersEntity {
  id: number;
  countries_id?: null;
  countries_ids?: number[] | null;
  cities_ids?: null[] | null;
  industries_ids?: null[] | null;
  sectors_ids?: null[] | null;
  institutes_ids?: null[] | null;
  faculty_tags?: null[] | null;
  macro_study_tags_ids?: null;
  study_tags_ids?: null;
  course_tags?: null[] | null;
  locations_ids?: null[] | null;
  use_profile_locations_id?: null;
  use_profile_institutes_id: boolean;
  use_profile_cities_id: boolean;
  use_profile_countries_id: boolean;
  use_profile_study_tag: boolean;
  use_profile_macro_study_tag: boolean;
  tags: string;
  cities_id?: null;
  universities_id?: null;
  faculty_tag?: null;
  course_tag?: null;
  is_internal: boolean;
  filter_definitions_id: number;
  countries?: CountriesEntity[] | null;
  cities?: any[] | null;
  study_tags?: any[] | null;
  macro_study_tags?: any[] | null;
  institutes?: any[] | null;
}
export class CountriesEntity {
  id: number;
  name: string;
  view: boolean;
  tag: string;
  created_at: string;
  updated_at: string;
}
export class _Sector {
  id: number;
  name_it: string;
  name_en: string;
  name_fr: string;
  name_de: string;
  name_es: string;
  users_id?: null;
  view: boolean;
  created_at: string;
  updated_at: string;
}
export class _Type {
  id: number;
  name_it: string;
  name_en: string;
  name_fr: string;
  name_de: string;
  name_es: string;
  users_id: number;
  view: boolean;
}
export class TeamHasJobOffer {
  teams_id: number;
  job_offers_id: number;
  created_by: number;
  created_at: string;
  updated_at: string;
}
